var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.rangeDialog,
        width: "50%",
        title: _vm.type == "cinema" ? "影院信息" : "客户信息",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.rangeDialog = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          staticClass: "home__search",
          attrs: { data: _vm.searchForm, inline: "" },
        },
        [
          _vm.type == "custom"
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户ID" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.searchForm.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "id", $$v)
                          },
                          expression: "searchForm.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户名称" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.searchForm.company_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "company_name", $$v)
                          },
                          expression: "searchForm.company_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.searchData },
                        },
                        [_vm._v("查 询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.type == "cinema"
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "影院编码" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.searchForm.standard_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "standard_id", $$v)
                          },
                          expression: "searchForm.standard_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "影院名称" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.searchForm.cinema_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "cinema_name", $$v)
                          },
                          expression: "searchForm.cinema_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.searchData },
                        },
                        [_vm._v("查 询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-table",
        {
          key: _vm.type,
          ref: "multipleTable",
          staticStyle: { height: "300px", overflow: "auto" },
          attrs: {
            border: "",
            stripe: true,
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.list,
          },
        },
        [
          _vm.type == "custom"
            ? _c("el-table-column", {
                attrs: { label: "客户ID", width: "80px", prop: "id" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [_vm._v(" " + _vm._s(scope.row.id) + " ")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3953508924
                ),
              })
            : _vm._e(),
          _vm.type == "custom"
            ? _c("el-table-column", {
                attrs: { label: "客户名称", prop: "company_name" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.row.company_name) + " "),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3572834382
                ),
              })
            : _vm._e(),
          _vm.type == "cinema"
            ? _c("el-table-column", {
                attrs: { label: "城市" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.province_name) +
                                "/" +
                                _vm._s(scope.row.city_name) +
                                "/" +
                                _vm._s(scope.row.area_name) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3682051811
                ),
              })
            : _vm._e(),
          _vm.type == "cinema"
            ? _c("el-table-column", {
                attrs: { label: "影院编码", prop: "standard_id" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.row.standard_id) + " "),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1603169880
                ),
              })
            : _vm._e(),
          _vm.type == "cinema"
            ? _c("el-table-column", {
                attrs: { label: "影院名称", prop: "cinema_name" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.row.cinema_name) + " "),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1023818500
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            "text-align": "right",
            "margin-top": "10px",
            "padding-bottom": "10px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total,sizes, prev, pager, next, jumper",
              "page-size": 5,
              "page-sizes": [5, 50, 100, 200],
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.onChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }